<template>
    <div class="d-flex talk__container">
        <b-button
            id="request-feedback"
            class="btn btn-icon-button text-white mr-1"
            @click="openRequestFeedbackModal"
        >
            <span>
                {{ $t('form.button.requestFeedback') }}
            </span>
            <i class="fa fa-arrow-down right-icon-button"></i>
        </b-button>
        <b-button
            id="send-feedback"
            class="btn btn-icon-button text-white"
            @click="openSendFeedbackModal"
        >
            <span>
                {{ $t('form.button.send') }}
            </span>
            <i class="fa fa-arrow-up right-icon-button"></i>
        </b-button>
    </div>
</template>

<script>
export default {
    name: 'Talk',
    props: {
        userID: {
            type: [Number, String],
            required: true,
        },
    },
    methods: {
        openRequestFeedbackModal() {
            this.$router.push({
                path: `/v2/profile/${this.userID}/feedbacks/request`,
            })
        },
        openSendFeedbackModal() {
            this.$router.push({
                path: `/v2/profile/${this.userID}/feedbacks/send`,
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.btn {
    background-color: #009bdb;
    border-color: #009bdb;
    width: 50%;
}

.fa {
    background: #0a83b5;
}

.btn-brand {
    width: 100%;
}

.btn-brand i {
    margin-left: auto !important;
}

.talk__container {
    width: 100%;
    flex-flow: column;

    button {
        width: 100%;
    }

    #send-feedback {
        margin-top: 10px;
    }
}

@media (min-width: 1200px) {
    .talk__container {
        flex-flow: row;

        #send-feedback {
            margin-top: 0;
        }
    }
}
</style>
